module.exports = __webpack_public_path__ + "assets/img/cw-bwh.f2896e2a.png";